import React, { useState, useEffect } from "react";
import { Input, Form, Switch, Spin, Select, Dropdown } from "antd";
import columns from "../../columns/Subadmin.js";
import ConfirmationModal from "../../components/global/modal/ConfirmationModal.jsx";
import TableWithSkeleton from "../../components/global/table/TableWithSkeleton.jsx";
import ModalComponent from "../../components/global/modal/ModalComponent.jsx";
import Edit from "../../assets/Edit.jsx";
import Account from "../../assets/Account.jsx";
import IbApproved from "../../assets/IbApproved.jsx";
import Kyc from "../../assets/Kyc.jsx";
import Inbox from "../../assets/Task.jsx";
import Withdraw from "../../assets/EmailTemplate.jsx";
import Wallet from "../../assets/wallet/Wallet.jsx";
import Ticket from "../../assets/support/Ticket.jsx";
import {
  AddSubadmin,
  GetAllSubadmin,
  GetSubadminsAndPermissionApi,
  updatePermissionBysubadmin,
  DeactiveUser,
  DeleteSubadmin,
  ChangePasswordApi,
} from "../../api/request/subadmin.js";
import toast from "react-hot-toast";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import moment from "moment";
import { useSelector } from "react-redux";
import UserAvatar from "../../components/global/avtar/UserAvatar.jsx";
import Lock from "../../assets/auth/Lock.jsx";
import Setting from "../../assets/Setting.jsx";

export default function Subadmin() {
  const userDetails = useSelector((state) => state.user.userDetails);
  let isSalesManager = userDetails?.roleId === 6;

  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isSubadminsAndPermissionLoading, setIsSubadminsAndPermissionLoading] =
    useState(false);
  const [subadminsAndPermissionData, setSubadminsAndPermissionData] = useState(
    []
  );
  const [isAddSubadminLoading, setIsAddSubadminLoading] = useState(false);
  const [isUpdateSubadminLoading, setIsUpdateSubadminLoading] = useState(false);
  const [isAddSubadmin, setIsAddSubadmin] = useState(false);
  const [isEditSubadmin, setIsEditSubadmin] = useState(false);
  const [isStatusConfirmOpen, setIsStatusConfirmOpen] = useState(false);
  const [isStatusConfirmLoading, setIsStatusConfirmLoading] = useState(false);
  const [selectedSubadmin, setSelectedSubadmin] = useState(null);
  const [data, setData] = useState([]);
  const [selectedsubid, setSelectedSub] = useState(null);
  const primaryColor = getComputedStyle(document.documentElement)
    .getPropertyValue("--theme")
    ?.trim();
  const [totalRecord, setTotalRecord] = useState(0);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isChangePassword, setIsChangePassword] = useState(false);
  const [isPasswordLoading, setIsPasswordLoading] = useState(false);
  const [initialChangePasswordValue, setInitialChangePasswordValue] = useState({
    password: "",
    confirmPassword: "",
  });

  const statusHandler = async (role) => {
    setSelectedSub(role);
    setIsStatusConfirmOpen(true);
  };

  const getSubadmin = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetAllSubadmin();
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              name: (
                <UserAvatar
                  data={{
                    name: `${item?.firstName} ${item?.lastName}`,
                    email: item?.email,
                  }}
                />
              ),
              createdDate: moment(item?.createdDate).format("DD-MM-YYYY, LT"),
              status: (
                <Switch
                  onChange={() => statusHandler(item)}
                  checkedChildren="On"
                  unCheckedChildren="Off"
                  checked={item?.isActive}
                />
              ),
              actions: (
                <div className="flex items-center gap-2">
                  <Dropdown
                      menu={{
                        items: [
                          {
                            key: 'change-password',
                            label: (
                              <div onClick={() => changePasswordHandler(item)}>
            Change Password
                              </div>
                            ),
                          },
                        ],
                      }}
                      placement="bottomLeft"
                      arrow
                      trigger={["click"]}
                    >
                      <div className="cursor-pointer">
                        <Setting />
                      </div>
                    </Dropdown>

                  <button
                    className={`${item?.roleName === 'TeamMember' ? '' : 'opacity-50 cursor-not-allowed'}`} disabled={item?.roleName !== 'TeamMember'}
                    onClick={(e) => openEditHandler(item)}
                  >
                    <Edit />
                  </button>
                  <button
                    onClick={() => {
                      setIsDelete(true);
                      setDeleteId(item?.userId);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="#D91819"
                      className="w-6 h-6 cursor-pointer hover:stroke-[#aa0001] duration-500"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                      />
                    </svg>
                  </button>
                </div>
              ),
            };
          })
        );
      }
      setTotalRecord(data?.totalRecords || 0);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  const handleDelete = async (id) => {
    setIsLoading(true);
    try {
      const { data } = await DeleteSubadmin(id);
      if (data?.success) {
        toast.success(data?.message);
        setIsDelete(false);
        getSubadmin();
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsLoading(false);
    }
  };
  const handleChangePassword = async (values) => {
    const { password, confirmPassword } = values;
    const params = { userId: selectedUserId, password, confirmPassword };
    if (password !== confirmPassword) {
      toast.error("New password and confirm password do not match.");
      return;
    }
    try {
      setIsPasswordLoading(true);
      const { data } = await ChangePasswordApi(params);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        setIsPasswordLoading(false);
      } else {
        toast.error(data?.message);
        setIsPasswordLoading(false);
      }
      setIsChangePassword(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setIsPasswordLoading(false);
      setIsChangePassword(false);
    }
  };
  const changePasswordHandler = (subAdminDetails) => {
    setSelectedUserId(subAdminDetails?.userId);
    setIsChangePassword(true);
  };
  useEffect(() => {
    if (!isChangePassword) {
      form.resetFields();
      setInitialChangePasswordValue({ password: "", confirmPassword: "" });
    }
  }, [isChangePassword]);
  const statusChangeConfirm = async () => {
    try {
      setIsStatusConfirmLoading(true);

      const { data } = await DeactiveUser({
        userId: selectedsubid?.userId,
        isActive: !selectedsubid?.isActive,
      });
      if (data?.success) {
        getSubadmin();
        toast.success(data?.message);
      } else {
        toast.error(data?.message);
      }

      setIsStatusConfirmLoading(false);
      setIsStatusConfirmOpen(false);
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsStatusConfirmLoading(false);
    }
  };

  const handleSubmit = async (value) => {
    try {
      setIsAddSubadminLoading(true);
      const { data } = await AddSubadmin(value);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        setIsAddSubadminLoading(false);
        setIsAddSubadmin(false);
        getSubadmin();
      } else {
        toast.error(data?.message);
        setIsAddSubadminLoading(false);
      }
    } catch (error) {
      toast.error(error?.response?.data?.error?.message);
      setIsAddSubadminLoading(false);
    }
  };

  const handleSubadminChange = (modulePermissionId, haveModulePermission) => {
    setSubadminsAndPermissionData((prevModules) =>
      prevModules.map((module) =>
        module.modulePermissionId === modulePermissionId
          ? { ...module, haveModulePermission }
          : module
      )
    );
  };

  useEffect(() => {
    getSubadmin();
  }, []);

  useEffect(() => {
    if (!isAddSubadmin) {
      form.resetFields();
    }
  });

  const openEditHandler = (subadmin) => {
    getSubadminsAndPermissionById(subadmin?.userId);
    setSelectedSubadmin(subadmin);
    setIsEditSubadmin(true);
  };

  const getSubadminsAndPermissionById = async (subadminId) => {
    try {
      setIsSubadminsAndPermissionLoading(true);
      const { data } = await GetSubadminsAndPermissionApi(subadminId);
      if (data?.success) {
        setSubadminsAndPermissionData(data?.data);
      }
      setIsSubadminsAndPermissionLoading(false);
    } catch (error) {
      setIsSubadminsAndPermissionLoading(false);
    }
  };

  const getIcons = (title) => {
    switch (title) {
      case "Account":
        return <Account />;
      case "Ticket":
        return <Ticket />;
      case "Deposit":
        return <Wallet />;
      case "Inbox":
        return <Withdraw />;
      case "KYC":
        return <Kyc />;
      case "Withdraw":
        return <Inbox />;
      case "      ":
        return <IbApproved />;
    }
  };

  const updateSubadminsAndPermission = async () => {
    setIsUpdateSubadminLoading(true);
    try {
      let transformedArray = subadminsAndPermissionData.map((item) => ({
        modulePermissionId: item.modulePermissionId,
        moduleId: item.moduleId,
        isActive: item.haveModulePermission,
      }));
      const { data } = await updatePermissionBysubadmin(transformedArray);
      if (data.success) {
        setIsUpdateSubadminLoading(false);
        toast.success(data.message);
        setIsEditSubadmin(false);
      }
      // need to call api and pass -->> transformedArray
    } catch (error) {}
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:justify-end">
        <div className="flex">
          {!isSalesManager && (
            <div>
              <button
                className="export-btm flex items-center gap-2 bg-primary text-sm text-white font-medium capitalize px-9 py-2 rounded-lg themeHover  duration-400"
                onClick={(e) => setIsAddSubadmin(true)}
                size="large"
              >
                <img
                  src="assets/icons/add_icon.svg"
                  alt="icon"
                  className=" "
                  width={12}
                />
                <span> Add Subadmin</span>
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="my-6">
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
          <TableWithSkeleton
            columns={columns}
            data={data}
            loading={isLoading}
            hiddenColumns={isSalesManager ? ["Actions", "Status"] : []}
          />
        </div>
      </div>

      <ConfirmationModal
        isOpen={isStatusConfirmOpen}
        setIsOpen={setIsStatusConfirmOpen}
        message="Are you sure to change the Subadmin status?"
        onConfirm={statusChangeConfirm}
        isLoading={isStatusConfirmLoading}
        loadingLabel="Changing status..."
      />

      {/* Add subadmin */}
      <ModalComponent
        isOpen={isAddSubadmin}
        setIsOpen={setIsAddSubadmin}
        title={<div className="font-bold text-lg">Add Sub Admin</div>}
        onCancel={() => setIsAddSubadmin(false)}
        width={800}
      >
        <Form
          className="w-full"
          autoComplete="off"
          form={form}
          onFinish={handleSubmit}
        >
          <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-5">
            <div className="input-white">
              <label className="text-description text-[#2F2B3DCC] font-medium">
                First Name
              </label>
              <Form.Item
                name="firstName"
                rules={[
                  { required: true, message: "Please enter first name." },
                ]}
              >
                <Input placeholder="First name" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-description text-[#2F2B3DCC] font-medium">
                Last Name
              </label>
              <Form.Item
                name="lastName"
                rules={[{ required: true, message: "Please enter last name." }]}
              >
                <Input placeholder="Last name" className="mt-1 w-full py-2" />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-description text-[#2F2B3DCC] font-medium">
                Primary Email
              </label>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Please enter valid email.",
                  },
                ]}
              >
                <Input
                  placeholder="Primary email"
                  className="mt-1 w-full py-2"
                />
              </Form.Item>
            </div>
            <div className="input-white">
              <label className="text-description text-[#2F2B3DCC] font-medium">
                Phone No.
              </label>
              <Form.Item
                name="phoneNo"
                rules={[
                  {
                    required: true,
                    message: "Please enter valid phone number.",
                  },
                ]}
              >
                <Input
                  type="number"
                  placeholder="Phone no."
                  className="mt-1 w-full py-2"
                />
              </Form.Item>
            </div>
            <div className="ant-select-selector-white">
              <label className="text-base text-[#2F2B3DCC] font-medium">
                Role
              </label>
              <Form.Item
                name="RoleType"
                rules={[{ required: true, message: "Please select a role." }]}
              >
                <Select
                  placeholder="Select a role"
                  className="w-full mt-1 "
                  options={[
                    { value: 5, label: "Team Member" },
                    { value: 6, label: "Sales Manager" },
                    { value: 3, label: "Sub Admin" },
                  ]}
                />
              </Form.Item>
            </div>
          </div>
          <div className="flex justify-end mt-8">
            <LoadableButton
              className="bg-primary text-sm text-white font-semibold rounded-lg px-12 py-2 uppercase themeHover  duration-500"
              disabled={isAddSubadminLoading}
              type="Submit"
              lable="Submit"
              isLoading={isAddSubadminLoading}
              loadingLable="Adding subadmin..."
            />
          </div>
        </Form>
      </ModalComponent>

      {/* Edit subadmin */}
      <ModalComponent
        isOpen={isEditSubadmin}
        setIsOpen={setIsEditSubadmin}
        title={<div className="font-bold text-title">List of Permission</div>}
        onCancel={() => setIsEditSubadmin(false)}
        width={650}
      >
        {isSubadminsAndPermissionLoading ? (
          <div className="flex justify-center flex-col my-[10%]">
            <Spin size="large" />
            <p className="primary text-center mt-2">Loading...</p>
          </div>
        ) : (
          <div>
            <div className="grid lg:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-4 mt-2 px-4">
              {subadminsAndPermissionData.map((item, index) => (
                <div
                  key={index}
                  className="h-[100px] relative"
                  onClick={() =>
                    handleSubadminChange(
                      item?.modulePermissionId,
                      !item.haveModulePermission
                    )
                  }
                >
                  <div
                    className={`border rounded p-4 h-full flex flex-col justify-center items-center cursor-pointer duration-300 ${
                      item?.haveModulePermission ? " border-primary" : ""
                    }`}
                  >
                    {item?.haveModulePermission && (
                      <div className="h-[10px] w-[10px] rounded-full absolute top-2 left-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          className="size-4"
                          stroke={primaryColor}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m4.5 12.75 6 6 9-13.5"
                          />
                        </svg>
                      </div>
                    )}
                    <div>{getIcons(item?.moduleName)}</div>
                    <p className="text-center subadmins-title ">
                      {item?.moduleName}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className=" text-center mt-6">
              <LoadableButton
                className="bg-primary text-base text-white font-medium uppercase px-9 py-2 rounded-lg themeHover duration-400"
                disabled={isUpdateSubadminLoading}
                type="Submit"
                lable="Save"
                isLoading={isUpdateSubadminLoading}
                loadingLable="Updating subadmin..."
                onClick={updateSubadminsAndPermission}
              />
            </div>
          </div>
        )}
      </ModalComponent>
      <ConfirmationModal
        isOpen={isDelete}
        setIsOpen={setIsDelete}
        message="Are you sure, you want to delete ?"
        isLoading={isLoading}
        loadingLabel="Removing..."
        onConfirm={() => handleDelete(deleteId)}
      />
      <ModalComponent
        isOpen={isChangePassword}
        setIsOpen={setIsChangePassword}
        title="Change Password"
      >
        <Form
          autoComplete="off"
          initialValues={initialChangePasswordValue}
          onFinish={handleChangePassword}
          form={form}
        >
          <div className="p-5 grid grid-cols-1 gap-6">
            <div>
              <p className="mb-1">New Password</p>
              <Form.Item
                name="password"
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "Please input your new password!",
                  },
                ]}
              >
                <Input.Password
                  size="large"
                  placeholder="New Password"
                  prefix={<Lock />}
                />
              </Form.Item>
            </div>
            <div>
              <p className="mb-1">Confirm Password</p>
              <Form.Item
                dependencies={["password"]}
                hasFeedback
                name="confirmPassword"
                rules={[
                  {
                    required: true,
                    message: "Please confirm your new password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "The new password that you entered do not match!"
                        )
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  size="large"
                  placeholder="Confirm Password"
                  prefix={<Lock />}
                />
              </Form.Item>
            </div>
            <div>
              <LoadableButton
                type="submit"
                className="w-full text-base font-medium py-2 px-2 rounded-lg text-white bg-primary themeHover"
                lable="Change Password"
                isLoading={isPasswordLoading}
                loadingLable="Updating..."
              />
            </div>
          </div>
        </Form>
      </ModalComponent>
    </div>
  );
}
